import { DatePipe } from '@angular/common';
import { Directive, effect, ElementRef, inject, Input } from '@angular/core';
import { ContextService } from 'app/core/services';
import { FeatureFlags } from '../services';
import { DateFormattingService } from '../services/date/date-formatting.service';

@Directive({
  selector: '[appDateWithOffset]',
  providers: [DatePipe],
})
export class DateWithOffsetDirective {
  private dateFormattingService = inject(DateFormattingService);
  private elementRef = inject(ElementRef);
  private contextService = inject(ContextService);
  private isAddOffsetFlagEnabled = this.contextService.isFeatureFlagEnabled(FeatureFlags.AddOffsetToDates);
  public offset = this.contextService.timeZoneOffset();

  @Input('appDateWithOffset') public formatPattern = '';

  constructor() {
    effect(() => {
      this.reformatDate(this.contextService.timeZoneOffset());
    });
  }

  public reformatDate(offset: number): void {
    if (this.isAddOffsetFlagEnabled) {
      const formatted = this.dateFormattingService.formatDateWithOffset(
        new Date(this.elementRef.nativeElement.textContent),
        this.formatPattern,
        offset,
      );

      if (formatted) {
        this.elementRef.nativeElement.textContent = formatted;
      }
    }
  }
}
